import React, { useState } from 'react';
import rideService from 'src/services/rideService';

const AddPaymentPopup = ({ isOpen, onClose, onSubmit, riderId, totalCommissionAmount, totalCommissionPaidAmount }) => {

  // State to manage the input value
  const [paidAmount, setPaidAmount] = useState('');
  const [error, setError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  // If the popup is not open, don't render anything
  if (!isOpen) {
    return null;
  }

  // Function to handle input value changes
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setPaidAmount(inputValue);
  };

  // Function to handle form submission
  const handleSubmit = () => {

    if (paidAmount == null || paidAmount == "") {
      setError("Something went wrong");
    } else {
      onSubmit(addRiderCommissionPaidAmount()); // Call the onSubmit prop with the updated value
      // onClose(); // Close the popup
    }

  };
  const addRiderCommissionPaidAmount = () => {
    const paymentDetail = {
      "rider_id": riderId,
      "paid_amount": paidAmount,
      "due_amount": (totalCommissionAmount - totalCommissionPaidAmount) - paidAmount
    }
    rideService.addRiderPaidCommissionAmount(paymentDetail).then((res) => {
      if (res.status == 200) {
        setIsSubmitted(true);
        window.location.reload();
      } else {
        setError("Something went wrong");
      }
    })
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded shadow-md">
        <h2 className="text-lg font-semibold mb-4">Add Payment</h2>
        {/* Input field to update the value */}
        <input
          type="number"
          value={paidAmount}
          onChange={handleInputChange}
          className="w-full border p-2 mb-4"
        />

        {error && <p className="text-red-500">{error}</p>}
        {/* Buttons for updating and canceling */}
        <div className="flex justify-end">
          <button
            onClick={handleSubmit}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Add Payment
          </button>
          <button
            onClick={onClose}
            className="ml-2 text-gray-600 hover:text-gray-800"
          >
            Cancel
          </button>
        </div>
        {isSubmitted ? (
          <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-4 mb-4">
            Submitted successfully!
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default AddPaymentPopup;